module.exports = __webpack_public_path__ + "static/img/11001B_2_3_R_20181212_fit.6050eca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/11001B_2_3_R_20181212_fit.png
// module id = LoES
// module chunks = 0